import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dimmer,
  Loader,
  Menu
} from 'semantic-ui-react';

import CreateModalWrapper from '_forms/createModal';
import ACCreateForm from '_forms/acBatchReseller'

import { post } from '_utils/xhr';
import { AC_TYPES } from '../../../server/constants';
import CreatedACLicensesList from './createdACList';
import moment from 'moment';

const PHASES = {
  FORM: 0,
  SUBMITTING: 1,
  COMPLETE: 2
};

const getInitData = () => ({
  addons: [],
  count: 1,
  source: 'max7',
  type: AC_TYPES.FULL,
  upgrade: false,
  expires_on: null,
  expires_days_after_init: null,
  description: ''
});

const CreateResellerACLicensesModal = ({
  reseller,
  onRefreshLicenses
}) => {

  const [open, setOpen] = useState(false);
  const [state, setState] = useState({ phase: PHASES.FORM, error: null, codes: null });

  const [data, setData] = useState(getInitData());

  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  const onReset = (e) => {
    e.preventDefault();
    setData(getInitData());
    setState({ phase: PHASES.FORM, error: null, codes: null });
  };

  const onFormChange = (name, value) => {
    const up = Object.assign({}, data, { [name]: value });

    // reset addons when changing source
    if (name === 'source') {
      up.addons = [];
    }

    if (name === "type") {
      switch (value) {
        case AC_TYPES.FULL: {
          up.expires_on = null;
          up.expires_days_after_init = null;
          break;
        }
        case AC_TYPES.TERM_DATE: {
          up.expires_days_after_init = null;
          break;
        }
        case AC_TYPES.TERM_DAYS:
        default: {
          up.expires_on = null;
          up.expires_days_after_init = 30;
          break;
        }
      }
    }

    if (up.expires_on) up.expires_on = moment(up.expires_on).utc().endOf('day').toDate();

    setData(up);
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    setState({ phase: PHASES.SUBMITTING, error: null, codes: null });

    const payload = Object.assign({}, data);

    // ISO Date if present
    if (payload.expires_on) {
      payload.expires_on = payload.expires_on.toISOString();
    }

    post(
      `/resellers/${encodeURIComponent(reseller._id)}/activationcodes`,
      payload
    )
      .then(codes => {
        // if (this.props.createBatch) {
        //   this.props.createBatch(body)
        // }
        setState({ phase: PHASES.COMPLETE, error: null, codes });
        onRefreshLicenses();
      })
      .catch(err => setState({ phase: PHASES.FORM, error: err, codes: null }));
  };

  return (
    <CreateModalWrapper
      header='Create New Reseller Activation Codes'
      subHeader={ reseller.name }
      open={ open }
      onClose={ onClose }
      onOpen={ onOpen }
      type='activation codes'
      trigger={
        <Menu.Item name='add_institution_acs'>
          <Button icon='ticket' content='Create Codes' />
        </Menu.Item>
      }
    >
      <div>
        <Dimmer inverted active={ state.phase === PHASES.SUBMITTING } >
          <Loader />
        </Dimmer>
        {
          state.phase === PHASES.FORM ? (
            <ACCreateForm
              data={ data }
              onChange={ onFormChange }
              onSubmit={ onFormSubmit }
              reseller={ reseller }
            />
          ) : null
        }
        {
          state.phase === PHASES.COMPLETE ? (
            <CreatedACLicensesList onReset={ onReset } codes={ state.codes || [] } />
          ) : null
        }
      </div>
    </CreateModalWrapper>
  );
}

CreateResellerACLicensesModal.propTypes = {
  reseller: PropTypes.object.isRequired,
  onRefreshLicenses: PropTypes.func.isRequired
};

export default CreateResellerACLicensesModal;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/createBatchResellerAcModal.js